<lms-breadcrumb [crumbs]="[{ label: 'students.label', icon: 'glicon-students', route: '/students' }]"></lms-breadcrumb>
<div *ngIf="license">
  <mat-tab-group
    class="tab-group"
    #tabGroup
    animationDuration="0ms"
    disableRipple="true"
    (selectedTabChange)="tabsManager.setTab($event)"
  >
    <mat-tab label="data">
      <ng-template mat-tab-label>{{ 'nouns.data' | translate }}</ng-template>
      <ng-template matTabContent>
        <div class="gl-context-menu__position tabGroup">
          <lms-button-actions *ngIf="showMenu || license.status === 'afterDemo'">
            <div class="gl-context-menu__options">
              <div *ngIf="license.status === 'afterDemo'">
                <span
                  *lmsProfileGuard="'students.finish-license'"
                  class="gl-context-menu__options--item"
                  (click)="setLicenseCompleted()"
                  >{{ 'licenses.complete.title' | translate }}</span
                >
              </div>
              <span
                *lmsProfileGuard="'licenses.delete'"
                class="gl-context-menu__options--item alert"
                (click)="unregister()"
                >{{ 'actions.delete' | translate }}</span
              >
            </div>
          </lms-button-actions>
        </div>
        <lms-license-editor [license]="license" (onSave)="onUpdateLicense($event)"></lms-license-editor>
      </ng-template>
    </mat-tab>
    <mat-tab label="emails">
      <ng-template mat-tab-label>{{ 'emails.label' | translate }}</ng-template>
      <ng-template matTabContent>
        <div class="margin-top">
          <lms-emails-list #emails [listId]="licenseEmailsListId" [options]="{ filters: filters, timezone: timezone }">
          </lms-emails-list>
        </div>
      </ng-template>
    </mat-tab>
    <mat-tab label="activity">
      <ng-template mat-tab-label>{{ 'nouns.activityReport' | translate }}</ng-template>
      <ng-template matTabContent>
        <lms-license-log #activity [license]="license" [course]="course"></lms-license-log>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</div>
